import React from "react";

import logo from "./img/acy_logo.svg";
import bannerAudi from "./img/banner_audi.jpg";
import bannerMc from "./img/banner_mclaren.jpg";
import bannerMercedes from "./img/banner_mercedes.jpg";
import bannerAudiMid from "./img/banner_audi_mid.jpg";
import bannerMcMid from "./img/banner_mclaren_mid.jpg";
import bannerMercedesMid from "./img/banner_mercedes_mid.jpg";
import fixAudi from "./img/fix_audi.png";
import fixMc from "./img/fix_mclaren.png";
import fixMercedes from "./img/fix_mercedes.png";
import fixCash from "./img/fix_cash.png";
import fixGold from "./img/fix_gold.png";
import fixHublot from "./img/fix_hublot.png";
import fixIphone from "./img/fix_iphone.png";
import smallAudi from "./img/small_audi.png";
import smallMc from "./img/small_mclaren.png";
import smallMercedes from "./img/small_mercedes.png";
import smallCash from "./img/small_cash.png";
import smallGold from "./img/small_gold.png";
import smallHublot from "./img/small_hublot.png";
import smallIphone from "./img/small_iphone.png";
import mcLarenLogo from "./img/mclaren_logo.svg";
import mercedesLogo from "./img/mercedes_logo.svg";
import audiLogo from "./img/audi_logo.svg";
import hublotLogo from "./img/hublot_logo.svg";
import goldLogo from "./img/gold_logo.svg";
import iphoneLogo from "./img/iphone_logo.svg";
import howTo1 from "./img/how_to_1.svg";
import howTo2 from "./img/how_to_2.svg";
import howTo3 from "./img/how_to_3.svg";
import howTo4 from "./img/how_to_4.svg";
import howTo5 from "./img/how_to_5.svg";
import icon1 from "./img/icon1.svg";
import icon2 from "./img/icon2.svg";
import icon3 from "./img/icon3.svg";
import icon4 from "./img/icon4.svg";
import icon5 from "./img/icon5.svg";
import icon6 from "./img/icon6.svg";
import reasonsImg from "./img/reasons_bg.png";
import enFlag from "./img/en_flag.svg";
import zhFlag from "./img/zh_flag.svg";
import idFlag from "./img/id_flag.svg";
import arFlag from "./img/ar_flag.svg";
import esFlag from "./img/es_flag.svg";
import viFlag from "./img/vi_flag.svg";

const baseUrl = process.env.REACT_APP_DOMAIN === 'acy-ch.com'
    ? 'https://acycn.cloud'
    : 'https://acy.cloud';
    
const pageDomain = process.env.REACT_APP_DOMAIN
    ? process.env.REACT_APP_DOMAIN
    : window.location.host;
   
export const data = {
    en: {
        // ###############################################################
        // ###############################################################
        // ###############################################################
        // ###############################################################
        // ###############################################################
        // ###############################################################
        // ###############################################################
        // ###############################################################
        // ###############################################################
        banner: {
            spin_now: "Spin Now",
            title: "Join Our Spin and Win Promotion and You Could Take Home Iconic Cars, Cash, or Gold",
            subtitle: "Double your Chance to Win Before the End of April 2024",
            logo,
            cars: [
                {
                    title: "McLaren GT",
                    img: bannerMc,
                    img_mid: bannerMcMid,
                },
                {
                    title: "Mercedes-Benz G-Class",
                    img: bannerMercedes,
                    img_mid: bannerMercedesMid,
                },
                {
                    title: "Audi RS 5 Coupé",
                    img: bannerAudi,
                    img_mid: bannerAudiMid,
                },
            ],
            lang_select: [
                {
                    img: enFlag,
                    text: "English",
                },
                {
                    img: zhFlag,
                    text: "中文",
                },
                {
                    img: arFlag,
                    text: "العربية",
                },
                {
                    img: idFlag,
                    text: "Bahasa",
                },
                {
                    img: esFlag,
                    text: "Español",
                },
                {
                    img: viFlag,
                    text: "Tiếng Việt",
                },
            ],
        },
        new_prizes: {
            title: "Awe-inspiring new prizes that make a statement",
            subtitle:
                'On offer this year is the breathtakingly beautiful McLaren GT, the legendary Mercedes "G-Class", the magnificent Audi RS 5 Coupe, the stylish Hublot watch, 10 ounces of Australian gold bars, Apple iPhone 15 Pro and multiple cash prizes of US$30, US$50, US$100, and US$500',
            bottom_title: "Every spin wins a prize",
            bottom_subtitle:
                "Minimum US$30 (in your base currency) is guaranteed",
            spin_now: "Spin Now",
            prizes: [
                smallMc,
                smallMercedes,
                smallAudi,
                smallHublot,
                smallGold,
                smallIphone,
                smallCash,
            ],
        },
        cars: [
            {
                title: "McLaren GT",
                price: "US $210,000",
                logo: mcLarenLogo,
                img: fixMc,
            },
            {
                title: "Mercedes-Benz G-Class",
                price: "US $140,000",
                logo: mercedesLogo,
                img: fixMercedes,
            },
            {
                title: "Audi RS 5 Coupé",
                price: "US $79,000",
                logo: audiLogo,
                img: fixAudi,
            },
        ],
        other_prizes: [
            {
                title: "Hublot Integral Blue Ceramic",
                price: "US$25,000",
                img: fixHublot,
                logo: hublotLogo,
                class_name: "hublot",
            },
            {
                title: "10 ounces of Gold",
                price: "US$19,000",
                img: fixGold,
                logo: goldLogo,
                class_name: "gold",
            },
            {
                title: "iPhone 15 Pro 512GB",
                price: "US$1,300",
                img: fixIphone,
                logo: iphoneLogo,
                class_name: "iphone",
            },
            {
                title: "Cash Prizes",
                price: "US$30, US$50, US$100 and US$500",
                img: fixCash,
                class_name: "cash",
            },
        ],
        how_to: {
            title: "How to participate in Spin & Win",
            subtitle: "Follow these five easy steps.",
            bottom1:
                "Spin & Win is available exclusively to clients of ACY Securities (ACY LTD) only.",
            bottom2: "All pictures shown are for illustration purpose only.",
            cards: [
                {
                    img: howTo1,
                    text: `If you’re not already a client, <a class="open-btn" href="#/">open a trading account</a> with ACY Securities.`,
                },
                {
                    img: howTo2,
                    text: 'Create a Finlogix account. <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
                },
                {
                    img: howTo3,
                    text: "Connect your Finlogix account to your ACY Securities trading account by a simple click",
                },
                {
                    img: howTo4,
                    text: `Deposit $2000 via your <a href="${baseUrl}?locale=en" target="__blank" >ACY Client Portal</a>` ,
                },
                {
                    img: howTo5,
                    text:`Click the wheel icon inside your <a href="${baseUrl}?locale=en" target="__blank" >ACY Client Portal</a> and take your spin`
                },
            ],
        },
        wheel: {
            lang: "en",
            title: "Spin it, to win it",
            subtitle: "Login to your ACY Securities account or Register.",
            spin: "Spin & Win",
            button1: "Log in",
            button2: "Open an account",
            button3: "Logout",
            connect_btn: "Connect ",
            connect:
                "You haven't connect Finlogix, please click the connect button to sign up to Finlogix in one simple step ",
            hi: "Hi",
            click_btn: "Click the button to start spinning and winning.",
            left: "left",
            you_have: "You have",
            chance: "chance",
            chances: "chances",
            spin_min_deposite: "Minimum Deposit Required",
            spin_prize: "Prize",
            special_promo_title: "Special Spin & Win Offer​",
            special_promo_content: [
                'Special Spin & Win Offer period is from 1/3/2024 to 30/4/2024.​',
                'Clients who deposit $2,000 or more (in their account’s base currency), will earn 1 spin in the same month.',
                'A second deposit of $2,000 or more (in their account’s base currency) in the same calendar month, will earn another 1 spin. Limit of 2 spins per month applies during this promotion period.',
                'The second spin is granted under the same terms and conditions as the first spin.',
                'ACY LLC reserves the right for final prize determinations.',
                '2 spins per month',
                'Minimum win of US$30 per spin',
                'Minimum deposit varies based on the base currency of your trading account (see table above)'
            ],
            limit: "2 spins per month",
            minimum_win: "Minimum win of US$30 per spin",
            minimum_deposite: "Minimum deposit varies based on the base currency of your trading account (see table above)",
            switch_btn:"Switch account to spin",
            // download_Terms: 'Download Terms & Conditions',
            download_button: "Terms & Conditions",
            pdf: "https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms.pdf",
            deposit_pop: {
                title: "Oh no, you can't spin just yet",
                p1: "Clients who deposit at least US$2,000 (or equivalent) are eligible to spin.",
                p2: "Every spin wins a prize!",
                button: "Make a deposit now",
            },
            connect_finlogix_pop: {
                title: "Connect to Finlogix",
                p1: "To participate in the Spin and Win 2024, you need to create an account with Finlogix.",
                p2: " FInlogix is a free social trading community for traders, and has partnered with ACY Securities.",
                p3: "Click the button below to sign up to Finlogix in one simple step.",
                button: "Sign up to Finlogix",
                lang: "en",
            },
            congratulations_pop: {
                title: "Congratulations!",
                subtitle: "You have won a",
                p1: "Please check your email for the next steps to claim your prize.",
            },
            error_messages: {
                "-101": "Unfortunately, this promotion has ended.",
                "-102": "You have already used the opportunities for the lucky draw this month, there will be a surprise next month!",
                "-103": "The prize has been drawn out. To avoid miss out, please check the website for notifications about future promotions!",
                "-105": "server error",
                429: "too many requests",
            },

            not_start: "The start time of the campaign is",
            please_wait: "Please wait.",

            prize_name: {
                mclaren: "McLaren GT",
                audi: "Audi RS 5 Coupé",
                mercedes: "Mercedes-Benz G-Class",
                iphone: "iPhone 15 Pro 512GB",
                hublot: "Hublot Integral Blue Ceramic",
                gold: "10 ounces of Gold",
                cash30: "US$30 Cash Prize",
                cash50: "US$50 Cash Prize",
                cash100: "US$100 Cash Prize",
                cash500: "US$500 Cash Prize",
            },
        },
        spin: {
            title: "Spin it, to win it",
            subtitle: "Login to your ACY Securities account or Register.",
            open_an_account: "Open an account",
            log_in: "Log in",
            tac: "Terms & Conditions",
            bottom1: "Up to two spins per month",
            bottom1: "Every spin wins a minimum of US$30",
        },
        why_trade: {
            title: "Why trade with ACY Securities",
            subtitle:
                "With trading conditions that are second to none, full suite of resources to help you grow as a trader, and a choice of over 2,200 instruments to diversify your portfolio, join ACY today and discover your edge.",
            cards: [
                {
                    title: "Super-fast execution of orders",
                    subtitle: "Under 30ms",
                    img: icon1,
                },
                {
                    title: "Ultra-low-cost trading",
                    subtitle: "Spreads from 0.0 pips ",
                    img: icon2,
                },
                {
                    title: "24/5 Support",
                    subtitle: "Multi-lingual support",
                    img: icon3,
                },
                {
                    title: "Cut-through Market Analysis ",
                    subtitle: "Morning & Afternoon reports",
                    img: icon4,
                },
                {
                    title: "Premium Educational Resources ",
                    subtitle: "Customisable training",
                    img: icon5,
                },
                {
                    title: "2,200+ CFDs",
                    subtitle: "Trade CFDs on global markets",
                    img: icon6,
                },
            ],
        },
        reasons5: {
            title: `5 reasons to switch to ACY today`,
            img: reasonsImg,
            reasons: [
                {
                    reason_title: `Get direct access to our MT5 Platform & diversify your portfolio`,
                    reason_content: `Trade global shares with 1:25 leverage, FX and Metals with 1:500`,
                },
                {
                    reason_title: `Start trading FX spreads from zero pips`,
                    reason_content: `Spreads start from 0.0 pips | Execution speeds under 30ms`,
                },
                {
                    reason_title: `Get immediate access to daily trade calls & premium market analysis`,
                    reason_content: `Direct to your inbox, everyday!`,
                },
                {
                    reason_title: `No restrictions on Expert Adviser (EAs) or high-frequency trading`,
                    reason_content: `Trade the markets your way`,
                },
                {
                    reason_title: `Access over 2,200 instruments`,
                    reason_content: `Shares | FX | Commodities | Indices | ETFs | Cryptocurrencies`,
                },
            ],
        },
        sign_up: {
            title: "Don’t have an account with us yet? Sign up now!",
            open_an_account: "Open an account",
        },
        footer: {
            acyau: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. ACY Securities Pty Ltd (AFSL: 403863) provides general advice that does not consider your objectives, financial situation or needs. You should consider if you are part of our Target Market by reviewing our <a href="/en/support/terms-and-conditions">TMD</a> and read our <a href="/en/support/terms-and-conditions">FSG</a> and <a href="/en/support/terms-and-conditions">PDS</a> to ensure you fully understand the risks. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. </p><p>ACY Securities Pty Ltd is regulated by the Australian Securities and Investments Commission (ASIC AFSL:403863). Registered address: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL authorised us to provide financial services to Australian Residents or Businesses. </p>`,
            acyltd: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/en/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p><p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
            copyright:
                "© 2018 - 2024 ACY Securities is a brand name of ACY AU and ACY LLC, ACY Securities Pty Ltd. All right Reserved.",
            tac: "Terms of use ACY Securities Website",
        },
        form: {
            get_started: "Get Started",
            subtitle: "Register now for your chance to win",
            bottom_text: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. The KIS is available upon request or registration. If there is any advice on this site, it is general advice only.</p>
            
            <p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
        },
    },

    zh: {
        banner: {
            spin_now: "立即抽奖",
            title: "加入我们的旋转抽奖活动，您有机会赢得标志性汽车、现金或黄金",
            subtitle: "在2024年4月底之前，您的中奖机会翻倍",
            logo,
            cars: [
                {
                    title: "迈凯伦GT",
                    img: bannerMc,
                    img_mid: bannerMcMid,
                },
                {
                    title: "梅赛德斯-奔驰G系",
                    img: bannerMercedes,
                    img_mid: bannerMercedesMid,
                },
                {
                    title: "奥迪RS 5 Coupe",
                    img: bannerAudi,
                    img_mid: bannerAudiMid,
                },
            ],
            lang_select: [
                {
                    img: enFlag,
                    text: "English",
                },
                {
                    img: zhFlag,
                    text: "中文",
                },
                {
                    img: arFlag,
                    text: "العربية",
                },
                {
                    img: idFlag,
                    text: "Bahasa",
                },
                {
                    img: esFlag,
                    text: "Español",
                },
                {
                    img: viFlag,
                    text: "Tiếng Việt",
                },
            ],
        },
        new_prizes: {
            title: "豪华大礼令人瞩目",
            subtitle:
                "今年的大奖是惊艳颜值的迈凯伦GT、有传奇之称的梅赛德斯-奔驰G系、低调奢华的奥迪RS 5 Coupe、极具风格的宇舶表、10盎司黄金、iPhone 15 Pro及多重现金奖励（$30、$50、$100以及$500不等）",
            bottom_title: "幸运转盘百分百中奖",
            bottom_subtitle: "奖品最低保证$30",
            spin_now: "立即抽奖",
            prizes: [
                smallMc,
                smallMercedes,
                smallAudi,
                smallHublot,
                smallGold,
                smallIphone,
                smallCash,
            ],
        },
        cars: [
            {
                title: "迈凯伦GT",
                price: "US $210,000",
                logo: mcLarenLogo,
                img: fixMc,
            },
            {
                title: "梅赛德斯-奔驰G系",
                price: "US $140,000",
                logo: mercedesLogo,
                img: fixMercedes,
            },
            {
                title: "奥迪RS 5 Coupe ",
                price: "US $79,000",
                logo: audiLogo,
                img: fixAudi,
            },
        ],
        other_prizes: [
            {
                title: "宇舶表 Integral Blue Ceramic",
                price: "US $25,000",
                img: fixHublot,
                logo: hublotLogo,
                class_name: "hublot",
            },
            {
                title: "10盎司黄金",
                price: "US $19,000",
                img: fixGold,
                logo: goldLogo,
                class_name: "gold",
            },
            {
                title: "iPhone 15 Pro 512GB",
                price: "US $1,300",
                img: fixIphone,
                logo: iphoneLogo,
                class_name: "iphone",
            },
            {
                title: "现金奖励",
                price: "$30、$50、$100以及$500",
                img: fixCash,
                class_name: "cash",
            },
        ],
        how_to: {
            title: "如何参与幸运转盘",
            subtitle: "请遵循以下五个简单的步骤",
            bottom1: "仅ACY证券（ACY LTD）客户才能参与幸运转盘",
            bottom2: "所有图片仅供参考",
            cards: [
                {
                    img: howTo1,
                    text: '如果您还不是ACY证券的客户，请先<a class="open-btn" href="#/">开通一个交易账户</a>。',
                },
                {
                    img: howTo2,
                    text: '注册一个Finlogix融辑账户。<a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
                },
                {
                    img: howTo3,
                    text: "点击链接Finlogix融辑与ACY证券的交易账户。",
                },
                {
                    img: howTo4,
                    text: `通过<a href="${baseUrl}?locale=zh" target="__blank" >客户端后台</a>ACY.Cloud入金2000账户货币。`,
                },
                {
                    img: howTo5,
                    text: `在<a href="${baseUrl}?locale=zh" target="__blank" >客户端后台</a>点击轮盘图标进行抽奖。`,
                },
            ],
        },
        wheel: {
            lang: "zh",
            title: "转盘抽奖，赢取奖品",
            subtitle: "登录已有的ACY证券账户或注册新的账户。",
            spin: "幸运转盘",
            button1: "登录",
            button2: "开通账户",
            button3: "登出",
            connect_btn: "链接",
            connect:
                "如果您还没有链接Finlogix融辑账户，点击“链接”按钮，简单一步链接到Finlogix融辑账户。",
            hi: "您好",
            click_btn: "点击按钮进行转盘抽奖",
            left: "",
            you_have: "您还有",
            chance: "次机会",
            chances: "次机会",
            spin_min_deposite: "最低入金要求",
            spin_prize: "奖励",
            special_promo_title: "特别旋转与赢取优惠",
            special_promo_content: [
                '特别促销活动期限为2024年3月1日至2024年4月30日。',
                '客户需要入金至少$2,000账户货币将在当月获得一次抽奖机会。',
                '如果在同一个日历月内，第二次入金至少$2,000账户货币即可再获得一次抽奖机会。在此促销期间内，每个月的抽奖次数上限为2次。',
                '第二次抽奖所适用的活动条款与第一次抽奖相同',
                'ACY 证券保留最终奖品的决定权。',
                '每月两次抽奖机会',
                '每次抽奖赢取30美元',
                '最低入金金额根据您交易账户的基本货币而异（见上表）'
            ],
            limit: "每月两次抽奖机会",
            minimum_win: "每次抽奖赢取30美元",
            minimum_deposite: "最低入金金额根据您交易账户的基本货币而异（见上表）",
            switch_btn: "切换账户玩转盘",
            // download_Terms: 'Download Terms & Conditions',
            download_button: "条例与条款",
            pdf: "https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms-zh.pdf",
            deposit_pop: {
                title: "您还不能使用转盘抽奖",
                p1: "客户入金2000美元（或等价货币），就有机会转盘抽奖",
                p2: "幸运转盘百分百中奖",
                button: "点击此处入金",
            },
            connect_finlogix_pop: {
                title: "链接到Finlogix融辑账户",
                p1: "要参与2024幸运转盘，您需要开通一个Finlogix融辑账户。",
                p2: "Finlogix融辑是免费交易生态社区，与ACY证券深入合作。",
                p3: "点击下方按钮，简单一步注册Finlogix融辑账户。",
                button: "注册Finlogix融辑账户",
                lang: "zh",
            },
            congratulations_pop: {
                title: "恭喜您！",
                subtitle: "恭喜您赢取了",
                p1: "请查看您的邮箱，进行下一步领取奖品",
            },
            error_messages: {
                "-101": "很遗憾，活动已经结束了。",
                "-102": "您已经使用了本月的抽奖机会，请静候下个月的惊喜！",
                "-103": "奖品已经抽完。 不要错过下次活动，活动详情将发布在官网公告中！",
                "-105": "系统错误",
                429: "系统繁忙",
            },

            not_start: "活动的开始时间是",
            please_wait: "请您稍等",

            prize_name: {
                mclaren: "迈凯伦GT",
                audi: "奥迪RS 5 Coupe",
                mercedes: "梅赛德斯-奔驰G系",
                iphone: "iPhone 15 Pro 512GB",
                hublot: "宇舶表 Integral Blue Ceramic",
                gold: "10盎司黄金",
                cash30: "30美元现金奖励",
                cash50: "50美元现金奖励",
                cash100: "100美元现金奖励",
                cash500: "500美元现金奖励",
            },
        },

        why_trade: {
            title: "ACY证券的优势",
            subtitle:
                "凭借行业领先的交易环境，全套资源助您交易，以及超过2,200种金融商品的多元化投资选择，立即加入ACY，发掘您的交易潜能。",
            cards: [
                { title: "订单快速执行", subtitle: "低于30毫秒", img: icon1 },
                { title: "超低成本交易", subtitle: "点差低至0.0", img: icon2 },
                {
                    title: "交易日24小时服务",
                    subtitle: "多语言服务",
                    img: icon3,
                },
                {
                    title: "深入的市场分析",
                    subtitle: "早午间市场报告",
                    img: icon4,
                },
                {
                    title: "高级交易指导资源",
                    subtitle: "可定制培训",
                    img: icon5,
                },
                {
                    title: "2,200多种差价合约商品",
                    subtitle: "交易全球市场的差价合约商品",
                    img: icon6,
                },
            ],
        },
        reasons5: {
            title: `5个选择ACY平台交易的理由`,
            img: reasonsImg,
            reasons: [
                {
                    reason_title: `开始使用我们的MT5交易平台，多元化您的投资组合`,
                    reason_content: `全球股市交易杠杆1:25，外汇与金属杠杆1:500`,
                },
                {
                    reason_title: `外汇交易点差低至零`,
                    reason_content: `点差低至0.0|订单执行速度低于30毫秒`,
                },
                {
                    reason_title: `立即获取每日交易报告与高级市场分析`,
                    reason_content: `每天都会发送到您的邮箱！`,
                },
                {
                    reason_title: `对智能交易（EAs）与高频交易没有限制`,
                    reason_content: `以你自己的方式进行交易`,
                },
                {
                    reason_title: `可以交易2,200余种金融商品`,
                    reason_content: `股票|外汇|大宗商品|指数|ETFs|加密货币`,
                },
            ],
        },
        sign_up: {
            title: "即刻申请ACY证券交易账户!",
            open_an_account: "开通账户",
        },
        footer: {
            acyau: `<p>风险提示：外汇及其他金融衍生品交易风险极高，并不适合所有投资者。您并不拥有标的资产及其任何权益。在您决定进行外汇和金融衍生品交易投资之前，我们建议您考虑您的投资目标、风险承受能力以及交易经验。ACY Securities Pty Ltd（ AFSL：403863）提供一般性建议并未将您的投资目标、财务状况和需求考虑在内。请您务必在进行交易投资前，了解您是否属于我们的目标客户，并仔细阅读目标客户分类（<a href="/zh/support/terms-and-conditions/">TMD</a>）, 金融服务指南（<a href="/zh/support/terms-and-conditions/">FSG</a>）和产品披露申明（<a href="/zh/support/terms-and-conditions/">PDS</a>）确保清楚相关风险。本网站的内容不构成投资建议，如有任何疑问，请您咨询独立专业的财务或税务的意见。</p><p>ACY Securities Pty Ltd 由澳大利亚证券和投资委员会（ASIC AFSL：403863）授权和监管。注册地址：Level 18, 799 Pacific Hwy, Chatswood NSW 2067。AFSL授权我们为澳大利亚居民或企业提供服务。 </p>`,
            acyltd: `<p>风险提示：外汇及其他金融衍生品交易风险极高，并不适合所有投资者。您并不拥有标的资产及其任何权益。在您决定进行外汇和金融衍生品交易投资之前，我们建议您考虑您的投资目标、风险承受能力以及交易经验。您的交易亏损有可能超过原始投入。ACY Capital LLC (Company number: 2610 LLC 2022)仅提供一般建议，并未将您的投资目标、财务状况和需求考虑在内。本网站的内容不构成个人投资建议，如有任何疑问，请您咨询独立的财务或税务专家的意见。<a href='/zh/support/terms-and-conditions'>关键信息与条款文件</a>可应要求或在注册时提供。如果本网站上有任何建议，则仅为一般建议。</p><p>ACY Capital LLC (“ACY LLC”) ，ACY LLC 于圣文森特和格林纳丁斯注册成立（公司编号：2610 LLC 2022）。 注册地址：Suite 305, Griffith Corporate Centre, Beachmont, Kingstown。</p>`,
            copyright:
                "© 2018-2024 ACY证券是ACY AU和ACY LLC的品牌名称，本网站由ACY Securities Pty Ltd拥有和运营。",
            tac: "网站使用条款",
        },
        form: {
            get_started: "开始抽奖",
            subtitle: "立即注册，解锁奖品",
            bottom_text: `<p>风险提醒：外汇及其他金融衍生品交易风险极高，并不适合所有投资者。您并不拥有标的资产及其任何权益。在您决定进行外汇和金融衍生品交易投资之前，我们建议您考虑您的投资目标、风险承受能力以及交易经验。您需要知道交易外汇与衍生品，您的损失可能会超过您的初始投资额，所以不要投入您无法承担损失的金额。ACY Capital LLC (Company number: 2610 LLC 2022)只提供一般性建议，与个人的投资目标，财务状况或需求无关。此网站上的内容不能被解释为个人财务/投资建议；如果您有任何财务上的问题，请咨询独立财务顾问或税务顾问。此网站上的任何建议都只是一般性建议。您可随时要求关键信息声明，在您注册账户时，也会提供给您。</p>
            
            <p>ACY Capital LLC (“ACY LLC”) ，ACY LLC 于圣文森特和格林纳丁斯注册成立（公司编号：2610 LLC 2022）。 注册地址：Suite 305, Griffith Corporate Centre, Beachmont, Kingstown。。</p>`,
        },
    },

    id: {
        banner: {
            spin_now: "Putar Sekarang",
            title: "Bergabunglah dengan Promosi Putar dan Menang Kami dan Anda Bisa Bawa Pulang Mobil Ikonik, Uang Tunai, atau Emas",
            subtitle: "Gandakan Kesempatan Anda untuk Menang Sebelum Akhir April 2024",
            logo,
            cars: [
                {
                    title: "McLaren GT",
                    img: bannerMc,
                    img_mid: bannerMcMid,
                },
                {
                    title: "Mercedes-Benz G-Class",
                    img: bannerMercedes,
                    img_mid: bannerMercedesMid,
                },
                {
                    title: "Audi RS 5 Coupé",
                    img: bannerAudi,
                    img_mid: bannerAudiMid,
                },
            ],
            lang_select: [
                {
                    img: enFlag,
                    text: "English",
                },
                {
                    img: zhFlag,
                    text: "中文",
                },
                {
                    img: arFlag,
                    text: "العربية",
                },
                {
                    img: idFlag,
                    text: "Bahasa",
                },
                {
                    img: esFlag,
                    text: "Español",
                },
                {
                    img: viFlag,
                    text: "Tiếng Việt",
                },
            ],
        },
        new_prizes: {
            title: "Hadiah baru yang menakjubkan yang membuat pernyataan",
            subtitle:
                'Yang ditawarkan tahun ini adalah McLaren GT yang sangat cantik, Mercedes "G-Class" yang legendaris, Audi RS 5 Coupe yang megah, jam tangan Hublot yang trendi, emas batangan Australia 10 ons, Apple iPhone 15 Pro, dan berbagai hadiah uang tunai sebesar US $30 , US $50, US $100, dan US $500',
            bottom_title: "Setiap putaran memenangkan hadiah",
            bottom_subtitle:
                "Minimum US $ 30 (dalam mata uang dasar Anda) dijamin",
            spin_now: "Putar Sekarang",
            prizes: [
                smallMc,
                smallMercedes,
                smallAudi,
                smallHublot,
                smallGold,
                smallIphone,
                smallCash,
            ],
        },
        cars: [
            {
                title: "McLaren GT",
                price: "US $210,000",
                logo: mcLarenLogo,
                img: fixMc,
            },
            {
                title: "Mercedes-Benz G-Class",
                price: "US $140,000",
                logo: mercedesLogo,
                img: fixMercedes,
            },
            {
                title: "Audi RS 5 Coupé",
                price: "US $79,000",
                logo: audiLogo,
                img: fixAudi,
            },
        ],
        other_prizes: [
            {
                title: "Hublot Integral Keramik Biru",
                price: "US$25,000",
                img: fixHublot,
                logo: hublotLogo,
                class_name: "hublot",
            },
            {
                title: "10 ons Emas",
                price: "US$19,000",
                img: fixGold,
                logo: goldLogo,
                class_name: "gold",
            },
            {
                title: "iPhone 15 Pro 512GB",
                price: "US$1,300",
                img: fixIphone,
                logo: iphoneLogo,
                class_name: "iphone",
            },
            {
                title: "Hadiah Tunai",
                price: "US$30, US$50, US$100 danUS$500",
                img: fixCash,
                class_name: "cash",
            },
        ],
        how_to: {
            title: "Cara berpartisipasi dalam Spin & Win",
            subtitle: "Ikuti lima langkah mudah berikut.",
            bottom1:
                "Spin & Win tersedia secara eksklusif untuk klien ACY Securities (ACY LTD) saja.",
            bottom2:
                "Semua gambar yang ditampilkan hanya untuk tujuan ilustrasi.",
            cards: [
                {
                    img: howTo1,
                    text: 'Jika Anda belum menjadi klien, <a class="open-btn" href="#/">buka akun perdagangan </a>dengan ACY Securities.',
                },
                {
                    img: howTo2,
                    text: 'Buat akun Finlogix. <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
                },
                {
                    img: howTo3,
                    text: "Hubungkan akun Finlogix Anda ke akun perdagangan Sekuritas ACY dengan satu klik sederhana.",
                },
                {
                    img: howTo4,
                    text: `Setor $ 2000 melalui portal klien<a href="${baseUrl}?locale=id" target="__blank" >ACY.Cloud</a>  Anda.`,
                },
                {
                    img: howTo5,
                    text: `Klik ikon roda di dalam akun <a href="${baseUrl}?locale=id" target="__blank" >ACY.Cloud</a>  Anda dan lakukan putaran Anda.`,
                },
            ],
        },
        wheel: {
            lang: "id",
            title: "Putar, untuk memenangkannya",
            subtitle: "Login ke akun ACY Securities Anda atau Daftar.",
            spin: "Putar & Menang",
            button1: "Gabung",
            button2: "Membuka Akun",
            button3: "Keluar",
            connect_btn: "Terhubung",
            connect:
                "Anda belum terhubung ke Finlogix, silakan klik tombol hubungkan untuk mendaftar ke Finlogix dalam satu langkah mudah",
            hi: "Halo",
            click_btn: "Klik tombol untuk mulai memutar dan menang.",
            left: "",
            you_have: "Kamu Punya",
            chance: "Kesempatan",
            chances: "Peluang",
            spin_min_deposite: "Setoran Minimum Diperlukan",
            spin_prize: "Hadiah",
            special_promo_title: "Penawaran Khusus Putar & Menang",
            special_promo_content: [
                'Periode Penawaran Khusus Putar & Menang berlangsung dari 1/3/2024 hingga 30/4/2024.',
                'Klien yang melakukan deposit $2.000 atau lebih (dalam mata uang dasar akun mereka), akan mendapatkan 1 putaran di bulan yang sama.',
                'Deposit kedua sebesar $2.000 atau lebih (dalam mata uang dasar akun mereka) pada bulan kalender yang sama, akan menghasilkan 1 putaran lagi. Batas 2 putaran per bulan berlaku selama periode promosi ini.',
                'Putaran kedua diberikan dengan syarat dan ketentuan yang sama seperti putaran pertama.',
                'ACY LLC berhak atas penentuan hadiah akhir.',
                '2 putaran per bulan',
                'Kemenangan minimal US$30 per putaran',
                'Setoran minimum bervariasi berdasarkan mata uang dasar akun perdagangan Anda (lihat tabel di atas)'
            ],
            limit: "2 putaran per bulan",
            minimum_win: "Kemenangan minimal US$30 per putaran",
            minimum_deposite: "Setoran minimum bervariasi berdasarkan mata uang dasar akun perdagangan Anda (lihat tabel di atas)",
            switch_btn: "Beralih akun untuk berputar",
            // download_Terms: 'Download Terms & Conditions',
            download_button: "Syarat & Ketentuan",
            pdf: "https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms.pdf",
            deposit_pop: {
                title: "Oh tidak, Anda belum bisa berputar",
                p1: "Klien yang menyetor setidaknya US $ 2.000 (atau setara) berhak untuk memutar.",
                p2: "Setiap putaran memenangkan hadiah!",
                button: "Lakukan deposit sekarang",
            },
            connect_finlogix_pop: {
                title: "Hubungkan ke Finlogix",
                p1: "Untuk berpartisipasi dalam Spin dan Win 2024, Anda perlu membuat akun dengan Finlogix.",
                p2: "FInlogix adalah komunitas perdagangan sosial gratis untuk pedagang, dan telah bermitra dengan ACY Securities.",
                p3: "Klik tombol di bawah untuk mendaftar ke Finlogix dengan satu langkah mudah. ​​",
                button: "Daftar ke Finlogix",
                lang: "id",
            },
            congratulations_pop: {
                title: "Selamat!",
                subtitle: "Anda Menang",
                p1: "Silakan periksa email Anda untuk mengetahui langkah-langkah selanjutnya untuk mengklaim hadiah Anda.",
            },
            error_messages: {
                "-101": "Sayangnya, promosi ini telah berakhir.",
                "-102": "Anda sudah menggunakan peluang untuk undian bulan ini, akan ada kejutan bulan depan!",
                "-103": "Hadiah telah diundi. Untuk menghindari ketinggalan, silakan periksa situs web untuk pemberitahuan tentang promosi di masa mendatang!",
                "-105": "server error",
                429: "Terlalu Banyak permintaan",
            },

            not_start: "Waktu mulai kampanye adalah",
            please_wait: "Silahkan tunggu",

            prize_name: {
                mclaren: "McLaren GT",
                audi: "Audi RS 5 Coupé",
                mercedes: "Mercedes-Benz G-Class",
                iphone: "iPhone 15 Pro 512GB",
                hublot: "Hublot Integral Keramik Biru",
                gold: "10 ons Emas",
                cash30: "Hadiah Uang Tunai US $ 30",
                cash50: "Hadiah Uang Tunai US $ 50",
                cash100: "Hadiah Uang Tunai US $ 100",
                cash500: "Hadiah Uang Tunai US $ 500",
            },
        },
        why_trade: {
            title: "Mengapa berdagang dengan ACY Securities",
            subtitle:
                "Dengan kondisi perdagangan yang tiada duanya, rangkaian sumber daya lengkap untuk membantu Anda tumbuh sebagai pedagang, dan pilihan lebih dari 2,200 instrumen untuk mendiversifikasi portofolio Anda, bergabunglah dengan ACY hari ini dan temukan keunggulan Anda.",
            cards: [
                {
                    title: "Eksekusi order super cepat",
                    subtitle: "Di bawah 30 md",
                    img: icon1,
                },
                {
                    title: "Perdagangan berbiaya sangat rendah",
                    subtitle: "Spread mulai 0.0 pip",
                    img: icon2,
                },
                {
                    title: "Dukungan 24 jam 5 hari kerja",
                    subtitle: "Dukungan multibahasa",
                    img: icon3,
                },
                {
                    title: "Menembus Analisa Pasar",
                    subtitle: "Laporan Pagi & Sore",
                    img: icon4,
                },
                {
                    title: "Sumber Daya Pendidikan Premium",
                    subtitle: "Pelatihan yang dapat disesuaikan",
                    img: icon5,
                },
                {
                    title: "2,200+ CFDs",
                    subtitle: "Perdagangkan CFD di pasar global",
                    img: icon6,
                },
            ],
        },
        reasons5: {
            title: `5 alasan untuk beralih ke ACY hari ini`,
            img: reasonsImg,
            reasons: [
                {
                    reason_title: `Dapatkan akses langsung ke Platform MT5 kami & diversifikasi portofolio Anda`,
                    reason_content: `Perdagangkan saham global dengan leverage 1:25, FX dan Logam dengan 1: 500`,
                },
                {
                    reason_title: `Mulai perdagangan spread FX dari nol pips`,
                    reason_content: `Spread mulai dari 0.0 pips | Kecepatan eksekusi di bawah 30ms`,
                },
                {
                    reason_title: `Dapatkan akses langsung ke panggilan perdagangan harian & analisis pasar premium`,
                    reason_content: `Langsung ke kotak masuk Anda, setiap hari!`,
                },
                {
                    reason_title: `Tidak ada batasan pada Expert Adviser (EA) atau perdagangan frekuensi tinggi`,
                    reason_content: `Perdagangkan pasar sesuai keinginan Anda`,
                },
                {
                    reason_title: `Akses lebih dari 2,200 instrumen`,
                    reason_content: `Saham | FX | Komoditas | Indeks | ETF | Cryptocurrency`,
                },
            ],
        },
        sign_up: {
            title: "Belum punya akun dengan kami? Daftar sekarang!",
            open_an_account: "Membuka Akun",
        },
        footer: {
            acyau: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. ACY Securities Pty Ltd (AFSL: 403863) provides general advice that does not consider your objectives, financial situation or needs. You should consider if you are part of our Target Market by reviewing our <a href="/id/support/terms-and-conditions">TMD</a> and read our <a href="/id/support/terms-and-conditions">FSG</a> and <a href="/id/support/terms-and-conditions">PDS</a> to ensure you fully understand the risks. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. </p><p>ACY Securities Pty Ltd is regulated by the Australian Securities and Investments Commission (ASIC AFSL:403863). Registered address: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL authorised us to provide financial services to Australian Residents or Businesses. </p>`,
            acyltd: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/id/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p><p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
            copyright:
                "© 2018 - 2024 ACY Securities is a brand name of ACY AU and ACY LLC, ACY Securities Pty Ltd. All right Reserved.",
            tac: "Terms of use ACY Securities Website",
        },
        form: {
            get_started: "Memulai",
            subtitle: "Daftar sekarang untuk kesempatan menang Anda",
            bottom_text: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. The KIS is available upon request or registration. If there is any advice on this site, it is general advice only.</p>
            
            <p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
            },
    },

    vi: {
        banner: {
            spin_now: "Tham gia ngay bây giờ",
            title: "Tham gia Chương trình Quay và Trúng thưởng của chúng tôi và Bạn Có Thể Mang Về Xe Huyền Thoại, Tiền Mặt hoặc Vàng",
            subtitle: "Tăng Cơ Hội Trúng Thưởng của Bạn Trước Khi Hết Tháng 4 Năm 2024",
            logo,
            cars: [
                {
                    title: "Xe McLaren GT",
                    img: bannerMc,
                    img_mid: bannerMcMid,
                },
                {
                    title: "Xe Mercedes-Benz G-Class",
                    img: bannerMercedes,
                    img_mid: bannerMercedesMid,
                },
                {
                    title: "Xe Audi RS 5 Coupe",
                    img: bannerAudi,
                    img_mid: bannerAudiMid,
                },
            ],
            lang_select: [
                {
                    img: enFlag,
                    text: "English",
                },
                {
                    img: zhFlag,
                    text: "中文",
                },
                {
                    img: arFlag,
                    text: "العربية",
                },
                {
                    img: idFlag,
                    text: "Bahasa",
                },
                {
                    img: esFlag,
                    text: "Español",
                },
                {
                    img: viFlag,
                    text: "Tiếng Việt",
                },
            ],
        },
        new_prizes: {
            title: "Những giải thưởng mới tạo nên nguồn cảm hứng đó là một lời tuyền bố xác thực",
            subtitle:
                'Những giải thưởng năm nay vô cùng tuyệt vời như: các dòng xe hơi McLaren GT, Mercedes "G-Class", Audi RS 5 Coupe, đồng hồ Hublot sành điệu,Vàng 10g, iPhone 15 Pro và những giải thưởng tiền mặt giá trị khác (30,50,100,500 đôla)',
            bottom_title: "Mỗi lần quay đều sẽ nhận được giải thưởng",
            bottom_subtitle:
                "Đảm bảo nguồn vốn tối thiểu là 30 đôla (Căn cứ vào đơn vị tiền tệ của bạn)",
            spin_now: "Tham gia ngay bây giờ",
            prizes: [
                smallMc,
                smallMercedes,
                smallAudi,
                smallHublot,
                smallGold,
                smallIphone,
                smallCash,
            ],
        },
        cars: [
            {
                title: "Xe McLaren GT",
                price: "trị giá 210.000 Đôla",
                logo: mcLarenLogo,
                img: fixMc,
            },
            {
                title: "Xe Mercedes-Benz G-Class",
                price: "trị giá 140.000 Đôla",
                logo: mercedesLogo,
                img: fixMercedes,
            },
            {
                title: "Xe Audi RS 5 Coupe",
                price: "trị giá 76.000 Đôla",
                logo: audiLogo,
                img: fixAudi,
            },
        ],
        other_prizes: [
            {
                title: "Đồng hồ Hublot",
                price: "trị giá 25.000 Đôla",
                img: fixHublot,
                logo: hublotLogo,
                class_name: "hublot",
            },
            {
                title: "Vàng 10g",
                price: "trị giá 19.000 Đôla",
                img: fixGold,
                logo: goldLogo,
                class_name: "gold",
            },
            {
                title: "iPhone 15 Pro 512GB",
                price: "trị giá 1.300 Đôla",
                img: fixIphone,
                logo: iphoneLogo,
                class_name: "iphone",
            },
            {
                title: "Giải thưởng tiền mặt",
                price: "30 đôla, 50 đôla, 100 đôla, 500 đôla",
                img: fixCash,
                class_name: "cash",
            },
        ],
        how_to: {
            title: "Cách thức tham gia Spin & Win",
            subtitle: "Tiến hành theo 5 bước đơn giản",
            bottom1:
                "Spin & Win chỉ dành riêng cho khách hàng của ACY Securities (ACY LTD)",
            bottom2: "Tất cả hình ảnh hiển thị chỉ mang tính chất minh họa",
            cards: [
                {
                    img: howTo1,
                    text: 'Nếu bạn chưa phải là khách hàng trước đó hãy <a class="open-btn" href="#/">mở tài khoản giao dịch </a>với ACY Securities',
                },
                {
                    img: howTo2,
                    text: 'Tạo tại khoản Finlogix <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
                },
                {
                    img: howTo3,
                    text: "Kết nối tài khoản Finlogix của bạn với ACY Securities, Chỉ với thao tác nhấp chuột đơn giản",
                },
                {
                    img: howTo4,
                    text: `Gửi 2000 Đôla vào tài khoản <a href="${baseUrl}?locale=vi" target="__blank" >ACY của bạn</a>. Thông qua cổng ứng dụng`,
                },
                {
                    img: howTo5,
                    text: `Nhấp vào biểu tượng bánh xe bên trong tài khoản <a href="${baseUrl}?locale=vi" target="__blank" >ACY của bạn</a>. Thông qua cổng ứng dụng và tham gia ngay`,
                },
            ],
        },
        wheel: {
            lang: "vi",
            title: "Tham gia ngày để đoạt lấy giải thưởng",
            subtitle:
                "Đăng nhập vào tài khoản chứng khoán ACY của bạn hoặc đăng ký mới",
            spin: "Quay và giành giải thưởng",
            button1: "Đăng nhập vào tài khoản",
            button2: "Mở một tài khoản",
            button3: "Đăng xuất",
            connect_btn: "Kết nối",
            connect:
                "Bạn chưa kết nối với Finlogix, vui lòng nhấn vào nút bên dưới để đăng nhập vào Finlogix trong một bước đơn giản",
            hi: "Xin Chào",
            click_btn:
                "Nhấn vào nút bên dưới và bắt đầu quay và giành giải thưởng",
            left: "",
            you_have: "Bạn có",
            chance: "cơ hội",
            chances: "cơ hội",
            spin_min_deposite:"Tiền gửi tối thiểu bắt buộc",
            spin_prize: "Phần thưởng",
            special_promo_title: "Ưu Đãi Đặc Biệt Quay & Thắng",
            special_promo_content: [
                'Thời gian Ưu Đãi Đặc Biệt Quay & Thắng từ 1/3/2024 đến 30/4/2024.',
                'Khách hàng gửi từ 2.000 USD trở lên (bằng loại tiền cơ bản trong tài khoản của họ) sẽ kiếm được 1 lần quay trong cùng tháng.',
                'Khoản tiền gửi thứ hai từ 2.000 USD trở lên (bằng loại tiền cơ bản trong tài khoản của họ) trong cùng một tháng dương lịch sẽ kiếm được thêm 1 lần quay. Giới hạn 2 lần quay mỗi tháng được áp dụng trong thời gian khuyến mãi này.',
                'Vòng quay thứ hai được cấp theo các điều khoản và điều kiện tương tự như vòng quay đầu tiên.',
                'ACY LLC có quyền quyết định giải thưởng cuối cùng.',
                '2 lần quay mỗi tháng',
                'Tiền thắng tối thiểu là 30 đô la Mỹ cho mỗi lần quay',
                'Tiền gửi tối thiểu thay đổi dựa trên loại tiền tệ cơ bản trong tài khoản giao dịch của bạn (xem bảng ở trên)'
            ],
            limit: "2 lần quay mỗi tháng",
            minimum_win: "Tiền thắng tối thiểu là 30 đô la Mỹ cho mỗi lần quay",
            minimum_deposite: "Tiền gửi tối thiểu thay đổi dựa trên loại tiền tệ cơ bản trong tài khoản giao dịch của bạn (xem bảng ở trên)",
            switch_btn: "Chuyển tài khoản để quay",
            // download_Terms: 'Download Terms & Conditions',
            download_button: "Điều khoản và điều kiện",
            pdf: "https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms.pdf",
            deposit_pop: {
                title: "Ôi không! Bạn chưa thể quay ngay bây giờ",
                p1: "Khách hàng tham gia cần gửi đủ số tiền là 2000 đôla (Hoặc tương đương) sẻ đủ điều kiện tham gia vòng quay",
                p2: "Mỗi vòng quay đều giành được giải thưởng!",
                button: "Hãy gửi tiền ngay bây giờ!",
            },
            connect_finlogix_pop: {
                title: "Kết nối với Finlogix ngay",
                p1: "Để tham gia vào Spin and Win 2024, ban cần tạo một tài khoản liên kết với Finlogix",
                p2: "Finlogix là một cộng động giao dịch hoàn toàn miễn phí dành cho các nhà giao dịch và Finlogix đã hợp tác với ACY Securities",
                p3: "Nhấp vào nút bên dưới để đăng ký Finlogix trong một bước đơn giản.",
                button: "Đăng ký Finlogix",
                lang: "vi",
            },
            congratulations_pop: {
                title: "Chúc mừng bạn!",
                subtitle: "Bạn đã giành được",
                p1: "Vui lòng kiểm tra hộp thư của bạn để biết các bước tiếp theo để nhận giải thưởng",
            },
            error_messages: {
                "-101": "Thật không may chương trình khuyến mãi đã kết thúc",
                "-102": "Bạn đã sử dụng cơ hội bốc thăm may mắn tháng này, tháng sau sẽ có nhiều bất ngờ cho bạn!",
                "-103": "Giải thưởng đã được nhận. Để tránh bỏ lỡ, vui lòng cập nhật thông tin trên trang chủ để biết các thông báo về chương trình khuyến mãi trong tương lai!",
                "-105": "Lỗi máy chủ",
                429: "Quá nhiều yêu cầu",
            },

            not_start: "Thời gian bắt đầu của đợt này là",
            please_wait: "Vui lòng chờ đợi.",

            prize_name: {
                mclaren: "Xe McLaren GT",
                audi: "Xe Audi RS 5 Coupe",
                mercedes: "Xe Mercedes-Benz G-Class",
                iphone: "iPhone 15 Pro 512GB",
                hublot: "Đồng hồ Hublot",
                gold: "Vàng 10g",
                cash30: "Thưởng tiền mặt 30 đôla",
                cash50: "Thưởng tiền mặt 50 đôla",
                cash100: "Thưởng tiền mặt 100 đôla",
                cash500: "Thưởng tiền mặt 500 đôla",
            },
        },
        spin: {
            title: "Spin it, to win it",
            subtitle: "Login to your ACY Securities account or Register.",
            open_an_account: "Open an account",
            log_in: "Log in",
            tac: "Terms & Conditions",
            bottom1: "Up to two spins per month.",
            bottom1: "Every spin wins a minimum of US$30.",
        },
        why_trade: {
            title: "Tại sao phải giao dịch với ACY Securities",
            subtitle:
                "Với các điều kiện giao dịch không ai sánh kịp,Có nguồn tài nguyên đầy đủ để giúp bạn phát triển như một nhà giao dịch chân chính, có nhiều sự lựa chọn với hơn 2,200 công cụ để đa dạng hóa danh mục đầu tư của bạn, hãy tham gia ACY ngay hôm nay và khám phá lợi thế của bạn.",
            cards: [
                {
                    title: "Thực hiện đặt hàng nhanh chóng",
                    subtitle: "Dưới 30 mili giây",
                    img: icon1,
                },
                {
                    title: "Chi phí giao dịch cực thấp",
                    subtitle: "Độ chênh lệch từ 0.0 pips",
                    img: icon2,
                },
                {
                    title: "Hổ trợ 24/5",
                    subtitle: "Hổ trợ đa ngôn ngữ",
                    img: icon3,
                },
                {
                    title: "Phân tích giới hạn của thị trường",
                    subtitle: "Báo cáo mỗi buổi sáng và tối",
                    img: icon4,
                },
                {
                    title: "Nguồn tài nguyên giáo dục cao cấp",
                    subtitle: "Thời gian đào tạo linh hoạt",
                    img: icon5,
                },
                {
                    title: "2,200+ CFDs",
                    subtitle: "Giao dịch CFDs trên các thị trường toàn cầu",
                    img: icon6,
                },
            ],
        },
        reasons5: {
            title: `Có 5 lý do để tham gia ACY ngay hôm nay`,
            img: reasonsImg,
            reasons: [
                {
                    reason_title: `Nhận quyền truy cập trực tiếp vào nền tảng MT5 của chúng tôi và đa dạng hóa danh mục đầu tư của bạn`,
                    reason_content: `Giao dịch cổ phiếu toàn cầu với đòn bẩy 1:25, FX và Kim loại với 1: 500`,
                },
                {
                    reason_title: `Bắt đầu giao dịch chênh lệch FX từ 0 pips`,
                    reason_content: `Độ chênh lệch bắt đầu từ 0.0 pips, Tốc độ thực thi dưới 30 mili giây`,
                },
                {
                    reason_title: `Có quyền truy cập ngay vào các cuộc hội thoại và tìm hiểu các phân tích thị trường cao cấp`,
                    reason_content: `Nhận các thông tin trực tiếp vào hộp thư của bạn hàng ngày`,
                },
                {
                    reason_title: `Không có bất cử hạn chế nào với Cố Vấn Chuyên Gia (Eas) hoặc nhưng giao dịch có tần suất cao`,
                    reason_content: `Giao dịch hoàn toàn theo mong muốn của bạn`,
                },
                {
                    reason_title: `Có quyền sử dụng hơn 2,200 công cụ`,
                    reason_content: `Cổ phiếu, Ngoại hối, Hàng hóa, Chỉ số, ETFs, Tiền điện tử`,
                },
            ],
        },
        sign_up: {
            title: "Bạn chưa có tài khoản của chúng tôi? Hãy đăng ký ngay!",
            open_an_account: "Mở một tài khoản",
        },
        footer: {
            acyau: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. ACY Securities Pty Ltd (AFSL: 403863) provides general advice that does not consider your objectives, financial situation or needs. You should consider if you are part of our Target Market by reviewing our <a href="/vi/support/terms-and-conditions">TMD</a> and read our <a href="/vi/support/terms-and-conditions">FSG</a> and <a href="/vi/support/terms-and-conditions">PDS</a> to ensure you fully understand the risks. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. </p><p>ACY Securities Pty Ltd is regulated by the Australian Securities and Investments Commission (ASIC AFSL:403863). Registered address: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL authorised us to provide financial services to Australian Residents or Businesses. </p>`,
            acyltd: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/vi/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p><p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
            copyright:
                "© 2018 - 2024 ACY Securities is a brand name of ACY AU and ACY LLC, ACY Securities Pty Ltd. All right Reserved.",
            tac: "Terms of use ACY Securities Website",
        },
        form: {
            get_started: "Khởi động ngay",
            subtitle: "Đăng ký ngay để dành cơ hội chiến thắng",
            bottom_text: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. The KIS is available upon request or registration. If there is any advice on this site, it is general advice only.</p>
            
            <p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
          },
    },

    ar: {
        banner: {
            spin_now: "قم بإجراء السحب الآن",
            title: "انضم إلى عرضنا الدوار والفوز ويمكنك الحصول على سيارات أيقونية أو نقدًا أو ذهبًا",
            subtitle: "ضاعف فرصتك للفوز قبل نهاية أبريل 2024",
            logo,
            cars: [
                {
                    title: "سيارة McLaren GT",
                    img: bannerMc,
                    img_mid: bannerMcMid,
                },
                {
                    title: "سيارة Mercedes-Benz G-Class",
                    img: bannerMercedes,
                    img_mid: bannerMercedesMid,
                },
                {
                    title: "سيارة Audi RS 5 Coupé",
                    img: bannerAudi,
                    img_mid: bannerAudiMid,
                },
            ],
            lang_select: [
                {
                    img: enFlag,
                    text: "English",
                },
                {
                    img: zhFlag,
                    text: "中文",
                },
                {
                    img: arFlag,
                    text: "العربية",
                },
                {
                    img: idFlag,
                    text: "Bahasa",
                },
                {
                    img: esFlag,
                    text: "Español",
                },
                {
                    img: viFlag,
                    text: "Tiếng Việt",
                },
            ],
        },
        new_prizes: {
            title: "جوائز جديدة مذهلة ستحدث تغييراً لديك",
            // subtitle: '*$500 و\t،$100 ،$50 ،$30 :وجوائز نقدية متعددة Apple iPhone 15 Pro ،أونصات من سبائك الذهب الأسترالية\t 10  ،الأنيقة Hublot ساعة ،Audi RS 5 Coupe السيارة الرائعة،Mercedes "G-Class" الجميلة الآخذة للأنفاس، السيارة الأسطورية McLaren GT في عرض هذا العام: سيارة',
            subtitle:
                'في عرض هذا العام: سيارة McLaren GT الجميلة الآخذة للأنفاس، السيارة الأسطورية Mercedes "G-Class"، السيارة الرائعة Audi RS 5 Coupe، ساعة Hublot الأنيقة، 10 أونصات من سبائك الذهب الأسترالية، Apple iPhone 15 Pro وجوائز نقدية متعددة: $30، $50، $100، و $500',
            bottom_title: "في كل Spin ستربح جائزة",
            bottom_subtitle: "على الأقل 30$ (بعملتك المحلية) مضمومة",
            spin_now: "قم بإجراء السحب الآن",
            prizes: [
                smallMc,
                smallMercedes,
                smallAudi,
                smallHublot,
                smallGold,
                smallIphone,
                smallCash,
            ],
        },
        cars: [
            {
                title: "سيارة McLaren GT",
                price: "$210000",
                logo: mcLarenLogo,
                img: fixMc,
            },
            {
                title: "سيارة Mercedes-Benz G-Class",
                price: "$140,000",
                logo: mercedesLogo,
                img: fixMercedes,
            },
            {
                title: "سيارة Audi RS 5 Coupé",
                price: "$79,000",
                logo: audiLogo,
                img: fixAudi,
            },
        ],
        other_prizes: [
            {
                title: "ساعة يد من نوع Hublot Integral Blue Ceramic",
                price: "$25,000",
                img: fixHublot,
                logo: hublotLogo,
                class_name: "hublot",
            },
            {
                title: "10 أونصات من الذهب",
                price: "$19,000",
                img: fixGold,
                logo: goldLogo,
                class_name: "gold",
            },
            {
                title: "iPhone 15 Pro 512GB",
                price: "US$1,300",
                img: fixIphone,
                logo: iphoneLogo,
                class_name: "iphone",
            },
            {
                title: "جوائز نقدية",
                price: "$30, $50, $100, $500",
                img: fixCash,
                class_name: "cash",
            },
        ],
        how_to: {
            title: "كيفية المشاركة في Spin & Win",
            subtitle: "اتبع هذه الخطوات الخمس السهلة",
            bottom1: "Spin & Win متاح حصراً لعملاء ACY Securities (ACY LTD)",
            bottom2: "جميع الصور المعروضة هي لغرض التوضيح فقط.",
            cards: [
                {
                    img: howTo1,
                    text: 'إذا لم تكن عميلا بالفعل، <a class="open-btn" href="#/"> فافتح حساب تداول </a> مع ACY Securities',
                },
                {
                    img: howTo2,
                    text: 'إنشاء حساب على منصة Finlogix <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
                },
                {
                    img: howTo3,
                    text: "قم بربط حسابك في Finlogix بحساب تداول ACY Securities الخاص بك بنقرة واحدة.",
                },
                {
                    img: howTo4,
                    text: `قم بإيداع 2000$ عن طريق بوابة العميل <a href="${baseUrl}?locale=ar" target="__blank" >ACY.Cloud</a>`,
                },
                {
                    img: howTo5,
                    text: `انقر على رمز العجلة في <a href="${baseUrl}?locale=ar" target="__blank" >ACY.Cloud</a> وقم بالـ Spin الخاصة بك`,
                },
            ],
        },
        wheel: {
            lang: "ar",
            title: "أدر العجلة لربح جائزتك.",
            subtitle:
                "قم بتسجيل الدخول إلى حساب ACY Securities الخاص بك أو قم بالتسجيل.",
            spin: "عجلة Spin & Win",
            button1: "تسجيل الدخول",
            button2: "افتح حساب",
            button3: "تسجيل الخروج",
            connect_btn: "الاتصال",
            connect:
                "لم تقم بالتوصيل مع Finlogix، الرجاء النقر على زر الاتصال للتسجيل في Finlogix في خطوة واحدة بسيطة",
            hi: "مرحباً",
            click_btn: "انقر فوق الزر لبدء الـSpin & Win ",
            left: "",
            you_have: "أنت لديك",
            chance: "فرصة",
            chances: "فرص",
            spin_min_deposite:"الحد الأدنى للإيداع",
            spin_prize: "الجائزة",
            special_promo_title: "عرض خاص للدوران والفوز",
            special_promo_content: [
                'فترة العرض الخاص بالدوران والفوز هي من 1/3/2024 إلى 30/4/2024.',
                'العملاء الذين يقومون بإيداع مبلغ 2,000 دولار أو أكثر (بالعملة الأساسية لحسابهم)، سيحصلون على دورة واحدة في نفس الشهر.',
                'إيداع ثاني بمبلغ 2,000 دولار أو أكثر (بالعملة الأساسية لحسابهم) في نفس الشهر التقويمي، سيمكنك من الحصول على دورة واحدة إضافية. يتم تطبيق حد جولتين شهريًا خلال فترة العرض الترويجي هذه.',
                'يتم منح الدورة الثانية بنفس شروط وأحكام الدورة الأولى.',
                'تحتفظ ACY LLC بالحق في تحديد الجوائز النهائية.',
                '2 دورات شهريا',
                'الحد الأدنى للفوز 30 دولار في الدورة الواحدة',
                'يتغير الحد الأدنى للإيداع حسب العملة الأساسية لحساب التداول الخاص بك (انظر الجدول أعلاه) '
            ],
            limit:"2 دورات شهريا",
            minimum_win: "الحد الأدنى للفوز 30 دولار في الدورة الواحدة",
            minimum_deposite: "يتغير الحد الأدنى للإيداع حسب العملة الأساسية لحساب التداول الخاص بك (انظر الجدول أعلاه) ",
            switch_btn: "قم بتبديل الحساب لبدء اللعب ",
            // download_Terms: 'Download Terms & Conditions',
            download_button: "الشروط والأحكام",
            pdf: "https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms-ar.pdf",
            deposit_pop: {
                title: "للأسف، لا يمكنك القيام بـ Spin الآن.",
                p1: "العملاء الذين يودعون ما لا يقل عن 2000$ (أو ما يعادلها) مؤهلون للقيام بـ Spin.",
                p2: "كل Spin تربح جائزة",
                button: "قم بالإيداع الآن",
            },
            connect_finlogix_pop: {
                title: "التوصيل مع Finlogix",
                p1: "للمشاركة في Spin & Win 2024، تحتاج إلى إنشاء حساب مع Finlogix.",
                p2: "Finlogix هو مجتمع تداول اجتماعي مجاني للمتداولين، وهو شريك مع ACY Securities.",
                p3: "انقر فوق الزر أدناه للتسجيل في Finlogix في خطوة واحدة بسيطة.",
                button: "التسجيل في Finlogix",
                lang: "ar",
            },
            congratulations_pop: {
                title: "مبروك!",
                subtitle: "لقد فزت بـ",
                p1: "يرجى التحقق من بريدك الإلكتروني لمعرفة الخطوات التالية للمطالبة بجائزتك.",
            },
            error_messages: {
                "-101": "لسوء الحظ، انتهى هذا العرض.",
                "-102": "لقد استخدمت بالفعل فرص السحب لهذا الشهر، سيكون هناك مفاجأة الشهر المقبل!",
                "-103": "لقد تم سحب الجائزة. كي لا تفوتك الفرص المقبلة، يرجى مراجعة الموقع الإلكتروني للحصول على إشعارات حول العروض المستقبلية!",
                "-105": "خطأ في الخادم",
                429: "طلبات كثيرة",
            },

            not_start: "وقت بدء الحملة هو",
            please_wait: "الرجاء الانتظار",

            prize_name: {
                mclaren: "سيارة McLaren GT",
                audi: "سيارة Audi RS 5 Coupé",
                mercedes: "سيارة Mercedes-Benz G-Class",
                iphone: "iPhone 15 Pro 512GB",
                hublot: "ساعة يد من نوع Hublot Integral Blue Ceramic",
                gold: "10 أونصات من الذهب",
                cash30: "جائزة نقدية بقيمة 30$",
                cash50: "جائزة نقدية بقيمة 50$",
                cash100: "جائزة نقدية بقيمة 100$",
                cash500: "جائزة نقدية بقيمة 500$",
            },
        },

        why_trade: {
            title: "لماذا لتداول مع ACY Securities؟",
            subtitle:
                "مع ظروف تداول لا مثيل لها، ستحصل على مجموعة كاملة من المصادر لمساعدتك على تطوير نفسك كمتداول، وأكثر من 2,200 أداة تداول لتنويع محفظتك، انضم إلى ACY اليوم واكتشف المزيد من قدراتك.",
            cards: [
                {
                    title: "تنفيذ الأوامر بسرعة فائقة",
                    subtitle: "أقل من 30 ميلي ثانية",
                    img: icon1,
                },
                {
                    title: "تداول منخفض التكلفة للغاية",
                    subtitle: "فروق الأسعار من 0.0 نقطة",
                    img: icon2,
                },
                {
                    title: "دعم على مدار الساعة 5 أيام في الأسبوع",
                    subtitle: "دعم متعدد اللغات",
                    img: icon3,
                },
                {
                    title: "تحليل متميز للسوق",
                    subtitle: "تقارير الصباح وبعد الظهيرة",
                    img: icon4,
                },
                {
                    title: "مصادر تعليمية متميزة",
                    subtitle: "تدريب مخصص",
                    img: icon5,
                },
                {
                    title: "أكثر من 2,200 منتج من عقود الفروقات",
                    subtitle: "تداول العقود مقابل الفروقات في الأسواق العالمية",
                    img: icon6,
                },
            ],
        },
        reasons5: {
            title: `خمسة أسباب للتسجيل في ACY اليوم`,
            img: reasonsImg,
            reasons: [
                {
                    reason_title: `احصل على الوصول المباشر إلى منصة MT5 الخاصة بنا وقم بتنويع محفظتك`,
                    reason_content: `تداول الأسهم العالمية مع رافعة مالية 1:25، عملات ومعادن برافعة مالية 1:500`,
                },
                {
                    reason_title: `ابدأ تداول العملات الأجنبية مع فروق أسعار تبدأ من 0 نقطة`,
                    reason_content: `السبريد يبدأ من 0.0 نقطة | سرعات تنفيذ أقل من 30 مللي ثانية`,
                },
                {
                    reason_title: `إمكانية الوصول الفوري إلى الصفقات اليومية وتحليل متميز للسوق`,
                    reason_content: `مباشرة إلى البريد الوارد الخاص بك، كل يوم!`,
                },
                {
                    reason_title: `لا توجد قيود على الاكسبيرتات أو التداول عالي التردد`,
                    reason_content: `تداول الأسواق بطريقتك`,
                },
                {
                    reason_title: `الوصول إلى أكثر من 2,200 أداة تداول`,
                    reason_content: `الأسهم | العملات الأجنبية | السلع | المؤشرات | صناديق الاستثمار المتداولة | العملات المشفرة `,
                },
            ],
        },
        sign_up: {
            title: "ليس لديك حساب معنا بعد؟ سجل الآن!",
            open_an_account: "افتح حساب",
        },
        footer: {
            acyau: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. ACY Securities Pty Ltd (AFSL: 403863) provides general advice that does not consider your objectives, financial situation or needs. You should consider if you are part of our Target Market by reviewing our <a href="/ar/support/terms-and-conditions">TMD</a> and read our <a href="/ar/support/terms-and-conditions">FSG</a> and <a href="/ar/support/terms-and-conditions">PDS</a> to ensure you fully understand the risks. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. </p><p>ACY Securities Pty Ltd is regulated by the Australian Securities and Investments Commission (ASIC AFSL:403863). Registered address: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL authorised us to provide financial services to Australian Residents or Businesses. </p>`,
            acyltd: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/ar/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p><p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
            copyright:
                "© 2018 - 2024 ACY Securities is a brand name of ACY AU and ACY LLC, ACY Securities Pty Ltd. All right Reserved.",
            tac: "Terms of use ACY Securities Website",
        },
        form: {
            get_started: "البدء",
            subtitle: "سجل الآن للحصول على فرصتك للفوز",
            bottom_text: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. The KIS is available upon request or registration. If there is any advice on this site, it is general advice only.</p>
            
            <p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
          },
    },

    es: {
        banner: {
            spin_now: "Gire Ahora",
            title: "Únete a nuestra Promoción de Gira y Gana y podrías llevarte a casa Autos icónicos, Dinero en efectivo o Oro",
            subtitle: "Duplica tu Oportunidad de Ganar Antes de finales de abril de 2024",
            logo,
            cars: [
                {
                    title: "McLaren GT",
                    img: bannerMc,
                    img_mid: bannerMcMid,
                },
                {
                    title: "Mercedes-Benz G-Class",
                    img: bannerMercedes,
                    img_mid: bannerMercedesMid,
                },
                {
                    title: "Audi RS 5 Coupé",
                    img: bannerAudi,
                    img_mid: bannerAudiMid,
                },
            ],
            lang_select: [
                {
                    img: enFlag,
                    text: "English",
                },
                {
                    img: zhFlag,
                    text: "中文",
                },
                {
                    img: arFlag,
                    text: "العربية",
                },
                {
                    img: idFlag,
                    text: "Bahasa",
                },
                {
                    img: esFlag,
                    text: "Español",
                },
                {
                    img: viFlag,
                    text: "Tiếng Việt",
                },
            ],
        },
        new_prizes: {
            title: "Nuevos premios impresionantes que hacen una declaración",
            subtitle:
                'Este año se ofrece el increíblemente hermoso McLaren GT, el legendario Mercedes "G-Class", el magnífico Audi RS 5 Coupe, el elegante reloj Hublot, 10 onzas de lingotes de oro Australiano, Apple iPhone 15 Pro y múltiples premios en efectivo de US $ 30. , US $ 50, US $ 100 y US $ 500',
            bottom_title: "Cada giro tiene un premio",
            bottom_subtitle:
                "Se garantiza un mínimo de US $ 30 (en su moneda base)",
            spin_now: "Gire Ahora",
            prizes: [
                smallMc,
                smallMercedes,
                smallAudi,
                smallHublot,
                smallGold,
                smallIphone,
                smallCash,
            ],
        },
        cars: [
            {
                title: "McLaren GT",
                price: "US $210,000",
                logo: mcLarenLogo,
                img: fixMc,
            },
            {
                title: "Mercedes-Benz G-Class",
                price: "US $140,000",
                logo: mercedesLogo,
                img: fixMercedes,
            },
            {
                title: "Audi RS 5 Coupé",
                price: "US $79,000",
                logo: audiLogo,
                img: fixAudi,
            },
        ],
        other_prizes: [
            {
                title: "Hublot Integral Blue Ceramic",
                price: "US$25,000",
                img: fixHublot,
                logo: hublotLogo,
                class_name: "hublot",
            },
            {
                title: "10 onzas de Oro",
                price: "US$19,000",
                img: fixGold,
                logo: goldLogo,
                class_name: "gold",
            },
            {
                title: "iPhone 15 Pro 512GB",
                price: "US$1,300",
                img: fixIphone,
                logo: iphoneLogo,
                class_name: "iphone",
            },
            {
                title: "Premios en Efectivo",
                price: "US$30, US$50, US$100 y US$500",
                img: fixCash,
                class_name: "cash",
            },
        ],
        how_to: {
            title: "Como particiar en Gire & Gane",
            subtitle: "Siga los siguientes 5 pasos",
            bottom1:
                "Gire & Gane está disponible exclusivamente para clientes de ACY Securities (ACY LTD) únicamente.",
            bottom2:
                "Todas las imágenes que se muestran son solo para fines ilustrativos.",
            cards: [
                {
                    img: howTo1,
                    text: 'Si aún no es cliente, <a class="open-btn" href="#/">abra una cuenta de Trading</a> con ACY Securities.',
                },
                {
                    img: howTo2,
                    text: 'Cree una cuenta de Finlogix. <a href="https://www.finlogix.com/" target="__blank">www.finlogix.com</a>',
                },
                {
                    img: howTo3,
                    text: "Conecte su cuenta de Finlogix a su cuenta de Trading de ACY Securities con un simple clic.",
                },
                {
                    img: howTo4,
                    text: `Deposite $2000 a través de su portal de cliente <a href="${baseUrl}?locale=es" target="__blank" >ACY.Cloud</a>.`,
                },
                {
                    img: howTo5,
                    text: `Haga clic en el icono de la rueda dentro de su cuenta de <a href="${baseUrl}?locale=es" target="__blank" >ACY.Cloud</a> y gire la rueda.`,
                },
            ],
        },
        wheel: {
            lang: "en",
            title: "Gira para Ganar",
            subtitle: "Ingrese a su cuenta de ACY Securities o registrese",
            spin: "Gire & Gane",
            button1: "Ingrese",
            button2: "Abra una cuenta",
            button3: "Cerrar sesión",
            connect_btn: "Conectarse",
            connect:
                "No ha conectado Finlogix, haga clic en el botón de conexión para registrarse en Finlogix en un simple paso",
            hi: "Hola",
            click_btn: "Haga clic en el botón para comenzar a girar y ganar.",
            left: "left",
            you_have: "Tienes",
            chance: "Oportunidad",
            chances: "Oportunidades",
            spin_min_deposite: "Depósito mínimo requerido",
            spin_prize: "Premio",
            special_promo_title: "¡Oferta Especial Gira y Gana",
            special_promo_content: [
                'El período de la Oferta Especial Gira y Gana es del 1/3/2024 al 30/4/2024.',
                'Los clientes que depositen $2000 o más (en la moneda base de su cuenta) ganarán 1 giro en el mismo mes.',
                'Un segundo depósito de $2000 o más (en la moneda base de su cuenta) en el mismo mes calendario ganará 1 giro adicional. Durante este período de promoción se aplica un límite de 2 giros por mes.',
                'El segundo giro se otorga bajo los mismos términos y condiciones que el primer giro.',
                'ACY LLC se reserva el derecho de determinar el premio final.',
                '2 giro por mes',
                'Ganancia mínima de US$30 por giro',
                'El depósito mínimo varía según la divisa base de su cuenta de operaciones (consulte la tabla anterior)'
            ],
            limit: "2 giro por mes",
            minimum_win: "Ganancia mínima de US$30 por giro",
            minimum_deposite: "El depósito mínimo varía según la divisa base de su cuenta de operaciones (consulte la tabla anterior)",
            switch_btn: "Cambiar cuenta para girar",
            // download_Terms: 'Download Terms & Conditions',
            download_button: "Terminos y Condiciones",
            pdf: "https://docs.acygroup.com/Campaign/acy-securities-spin-and-win-terms.pdf",
            deposit_pop: {
                title: "Oh no, todavía no puedes girar",
                p1: "Los clientes que depositen al menos US $ 2,000 (o su equivalente) son elegibles para girar.",
                p2: "¡Cada giro gana un premio!",
                button: "Haz un depósito ahora",
            },
            connect_finlogix_pop: {
                title: "Conectarse a Finlogix",
                p1: "Para participar en el Gire & Gane 2024, debe crear una cuenta con Finlogix.",
                p2: "FInlogix es una comunidad de trading social gratuita para traders y se ha asociado con ACY Securities.",
                p3: "Haga clic en el botón de abajo para registrarse en Finlogix en un simple paso.",
                button: "Regístrese en Finlogix",
                lang: "en",
            },
            congratulations_pop: {
                title: "Felicitaciones!",
                subtitle: "Ha ganado un",
                p1: "Consulte su correo electrónico para conocer los siguientes pasos para reclamar su premio.",
            },
            error_messages: {
                "-101": "Desafortunadamente, esta promoción ha finalizado.",
                "-102": "Ya has aprovechado las oportunidades para el sorteo de este mes, ¡habrá una sorpresa el próximo mes!",
                "-103": "El premio se ha prolongado. Para evitar perderselo, consulte el sitio web para recibir notificaciones sobre futuras promociones.",
                "-105": "Error de Servidor",
                429: "demasiadas solicitudes",
            },

            not_start: "La hora de inicio de la campaña es",
            please_wait: "Por favor espere",

            prize_name: {
                mclaren: "McLaren GT",
                audi: "Audi RS 5 Coupé",
                mercedes: "Mercedes-Benz G-Class",
                iphone: "iPhone 15 Pro 512GB",
                hublot: "Hublot Integral Blue Ceramic",
                gold: "10 ounces of Gold",
                cash30: "Premio en efectivo de US$30",
                cash50: "Premio en efectivo de US$50",
                cash100: "Premio en efectivo de US$100",
                cash500: "Premio en efectivo de US$500",
            },
        },

        why_trade: {
            title: "Por que operar con ACY Securities",
            subtitle:
                "Con condiciones de trading insuperables, un conjunto completo de recursos para ayudarlo a crecer como trader y una selección de más de 2,200 instrumentos para diversificar su cartera, únase a ACY hoy y descubra su ventaja.",
            cards: [
                {
                    title: "Ultra-rapida ejecuciones de ordenes",
                    subtitle: "Menores a 30ms",
                    img: icon1,
                },
                {
                    title: "Ultra-bajo costo operativo",
                    subtitle: "Spreads desde 0.0 pips",
                    img: icon2,
                },
                {
                    title: "Soporte 24/5",
                    subtitle: "Soporte Multi-idioma",
                    img: icon3,
                },
                {
                    title: "Análisis de mercado",
                    subtitle: "Reportes Matutinos y Vespertinos",
                    img: icon4,
                },
                {
                    title: "Recursos Educacionales Premium",
                    subtitle: "Entrenamiento personalizable",
                    img: icon5,
                },
                {
                    title: "2,200+ CFDs",
                    subtitle: "Opere CFDs en Mercados Globales",
                    img: icon6,
                },
            ],
        },
        reasons5: {
            title: `5 razones para cambiarte a ACY hoy.`,
            img: reasonsImg,
            reasons: [
                {
                    reason_title: `Obtenga acceso directo a nuestra plataforma MT5 y diversifique su cartera`,
                    reason_content: `Negocie acciones globales con apalancamiento de 1:25, FX y metales con 1: 500`,
                },
                {
                    reason_title: `Empiece a operar FX con spreads desde zero pips`,
                    reason_content: `Los spreads comienzan desde 0,0 pips | Velocidades de ejecución inferiores a 30 ms`,
                },
                {
                    reason_title: `Obtenga acceso inmediato a llamadas comerciales diarias y análisis de mercado premium`,
                    reason_content: `Directo a su bandeja de entrada, todos los días!`,
                },
                {
                    reason_title: `Sin restricciones sobre asesores expertos (EA) o operaciones de alta frecuencia`,
                    reason_content: `Opere los Mercados a su manera`,
                },
                {
                    reason_title: `Acceda a más de 2,200 instrumentos`,
                    reason_content: `Acciones | FX | Commodities | Índices | ETF | CRIPTOMONEDAS`,
                },
            ],
        },
        sign_up: {
            title: "¿Aún no tienes una cuenta con nosotros? ¡Regístrate ahora!",
            open_an_account: "Open an account",
        },
        footer: {
            acyau: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. ACY Securities Pty Ltd (AFSL: 403863) provides general advice that does not consider your objectives, financial situation or needs. You should consider if you are part of our Target Market by reviewing our <a href="/es/support/terms-and-conditions">TMD</a> and read our <a href="/es/support/terms-and-conditions">FSG</a> and <a href="/es/support/terms-and-conditions">PDS</a> to ensure you fully understand the risks. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. </p><p>ACY Securities Pty Ltd is regulated by the Australian Securities and Investments Commission (ASIC AFSL:403863). Registered address: ACY Tower, Level 18, 799 Pacific Hwy, Chatswood NSW 2067. AFSL authorised us to provide financial services to Australian Residents or Businesses. </p>`,
            acyltd: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. <a href='/es/support/terms-and-conditions'>The KIS and Terms</a> are available upon request or registration. If there is any advice on this site, it is general advice only.</p><p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
            copyright:
                "© 2018 - 2024 ACY Securities is a brand name of ACY AU and ACY LLC, ACY Securities Pty Ltd. All right Reserved.",
            tac: "Terms of use ACY Securities Website",
        },
        form: {
            get_started: "Empezar",
            subtitle: "Regístrese ahora para tener la oportunidad de ganar",
            bottom_text: `<p>RISK WARNING: Foreign exchange and derivatives trading carries significant risk and is not suitable for all investors. You do not own, or have any interest in, the underlying assets. Before you decide to trade foreign exchange and derivatives, we encourage you to consider your investment objectives, your risk tolerance and trading experience. It is possible to lose more than your initial investment, so do not invest money you cannot afford to lose. ACY Capital LLC (Company number: 2610 LLC 2022) provides general advice that does not consider your objectives, financial situation or needs. The content of this website must not be construed as personal advice; please seek advice from an independent financial or tax advisor if you have any questions. The KIS is available upon request or registration. If there is any advice on this site, it is general advice only.</p>
            
            <p>ACY Capital LLC ('ACY LLC'), ACY LLC is incorporated in St Vincent and the Grenadines (Company number: 2610 LLC 2022). Registered address: Suite 305, Griffith Corporate Centre, Beachmont, Kingstown.</p>`,
           },
    },
};